import React from 'react';

import { Combobox, ComboboxOptionActionProps, Size } from '@lumapps/lumx/react';
import { Thumbnail } from '@lumapps/search-results/components/Thumbnail';
import { SEARCH_RESULT_TYPES } from '@lumapps/search/constants';

import { SearchBoxOptionWithItemProps } from '../../types';
import { SearchBoxOptionLabel } from '../SearchBoxOptionLabel';

interface BaseSearchBoxInteractionOptionProps extends SearchBoxOptionWithItemProps {
    before?: React.ReactNode;
    actionProps?: ComboboxOptionActionProps<any>;
    'data-id'?: string;
}

/**
 * Base component for all "interaction" type options.
 * This displays the thumbnail / label.
 */
export const BaseSearchBoxInteractionOption = ({
    suggestion,
    onSelect,
    id,
    className,
    after,
    before,
    actionProps,
    'data-id': dataId,
}: BaseSearchBoxInteractionOptionProps) => {
    const { thumbnail, entityType, icon, sourceUid } = suggestion.item;
    const charactersToDisplay = entityType === SEARCH_RESULT_TYPES.THIRD_PARTY ? 2 : 1;

    return (
        <Combobox.Option
            id={id}
            className={className}
            after={after}
            onClick={onSelect}
            value={suggestion.label}
            actionProps={actionProps}
            data-id={dataId}
            before={
                before ?? (
                    <Thumbnail
                        customizationContext={{
                            entityType,
                            mimeType: suggestion.mimeType,
                            sourceUid,
                        }}
                        iconName={thumbnail ? undefined : icon}
                        image={thumbnail}
                        alt=""
                        size={Size.s}
                        hasShape
                        charactersToDisplay={charactersToDisplay}
                    />
                )
            }
        >
            <SearchBoxOptionLabel label={suggestion.label} />
        </Combobox.Option>
    );
};
